export default [
  {
    path: "/contacts",
    name: "Contacts",
    component: () => import("../../views/Contacts/ContactList")
  },
  {
    path: "/contact/new",
    name: "ContactNew",
    component: () => import("../../views/Contacts/ContactNew")
  },
  {
    path: "/contact/edit/:uuid",
    name: "ContactEdit",
    props: true,
    component: () => import("../../views/Contacts/ContactEdit")
  },
  {
    path: "/contacts/view/:uuid",
    name: "ContactView",
    props: true,
    component: () => import("../../views/Contacts/ContactView")
  }
];
